import { SnackBarService } from './../../../data/repository/utils-repository/snack-bar.service';
import { BlogUserModel } from 'src/app/core/model/object/blog-user-model';
import { Component, OnInit, Input } from '@angular/core';
import { BlogTagModel } from 'src/app/core/model/object/blog-model';
import { BlogService } from 'src/app/data/repository/blog-repository/blog.service';
import { BlogShared } from '../../general/shared/blog-shared';
import { LoadingShared } from '../../general/shared/loading-shared';
import { TribuneAnalyticsService } from 'src/app/data/repository/analytics-repository/tribune-analytics.service';
import { TextHelper } from 'src/app/utils/text-helper';

@Component({
  selector: 'app-blog-search',
  templateUrl: './blog-search.component.html',
  styleUrls: ['./blog-search.component.scss'],
})
export class BlogSearchComponent implements OnInit {
  @Input() id: number = 10;

  page = 0;
  searchText;
  searchedTags: Array<BlogTagModel>;
  searchedUsers: Array<BlogUserModel>;

  showProfile = false;
  profileId = 11;
  selectedUsername = '';

  showBlogWithTag = false;
  tagId = 11;

  constructor(
    private blogService: BlogService,
    private blogShared: BlogShared,
    private loadingShared: LoadingShared,
    private tribuneAnalytics: TribuneAnalyticsService,
    private textHelper: TextHelper,
    private snackBarService: SnackBarService
  ) {
    this.searchedTags = [];
    this.searchedUsers = [];
  }

  ngOnInit() {}

  checkSearchVal() {
    const text = this.searchText;
    if (this.searchText && this.searchText !== '') {
      this.loadingShared.showLoading();
      if (this.page === 0) {
        this.blogService
          .searchTagAndUser(
            this.textHelper.replaceArabicLettersWithPersian(this.searchText)
          )
          .then((res) => {
            if (text === this.searchText) {
              this.searchedTags = [];
              this.searchedUsers = [];
              if (res.isSuccess()) {
                this.tribuneAnalytics.analyticTribuneSearched();
                this.searchedTags = res.getData().getBlogTagArray();
                this.searchedUsers = res.getData().getBlogUsers();
              } else {
                this.snackBarService.showSnackBar(
                  'خطا در برقراری ارتباط با سرور!'
                );
              }
            }
            this.loadingShared.hideLoading();
          });
      } else if (this.page === 1) {
        this.blogService
          .searchTag(
            this.textHelper.replaceArabicLettersWithPersian(this.searchText)
          )
          .then((res) => {
            if (text === this.searchText) {
              this.searchedTags = [];
              this.searchedUsers = [];
              if (res.isSuccess()) {
                this.tribuneAnalytics.analyticTribuneSearched();
                this.searchedTags = res.getData().getBlogTagArray();
              } else {
                this.snackBarService.showSnackBar(
                  'خطا در برقراری ارتباط با سرور!'
                );
              }
            }
            this.loadingShared.hideLoading();
          });
      } else {
        this.blogService
          .searchUser(
            this.textHelper.replaceArabicLettersWithPersian(this.searchText)
          )
          .then((res) => {
            if (text === this.searchText) {
              this.searchedTags = [];
              this.searchedUsers = [];
              if (res.isSuccess()) {
                this.tribuneAnalytics.analyticTribuneSearched();
                this.searchedUsers = res.getData().getBlogUsers();
              } else {
                this.snackBarService.showSnackBar(
                  'خطا در برقراری ارتباط با سرور!'
                );
              }
            }
            this.loadingShared.hideLoading();
          });
      }
    } else {
      this.searchedTags = [];
      this.searchedUsers = [];
    }
  }

  clearSearchText() {
    this.searchText = '';
    this.checkSearchVal();
  }

  openBlogWithTag(tag: BlogTagModel) {
    this.blogShared.blogSelectedTag = tag;
    this.tribuneAnalytics.analyticTribuneSearchResultClicked();
    this.blogService.goToSearchTag();
  }

  closeBlogWithTag() {
    this.blogShared.blogZIndex--;
    document.getElementById('blogWithTag' + this.id).style.right = '100%';
    setTimeout(() => {
      this.showBlogWithTag = false;
    }, 300);
  }

  profile(username: string) {
    this.blogService.goToUserProfile(username);

    // this.selectedUsername = username;
    // this.blogShared.blogZIndex++;
    // this.profileId = this.blogShared.blogZIndex;
    // this.showProfile = true;
    // setTimeout(() => {
    //   document.getElementById('profilePage' + this.id).style.zIndex =
    //     this.blogShared.blogZIndex.toString();
    //   document.getElementById('profilePage' + this.id).style.right = '0';
    // }, 100);
  }

  closeProfile() {
    this.blogShared.blogZIndex--;
    document.getElementById('profilePage' + this.id).style.right = '100%';
    // this._sharedService.animateDownButton();
    setTimeout(() => {
      this.showProfile = false;
    }, 300);
  }

  changePage(page: number) {
    this.page = page;
    this.checkSearchVal();
  }
  closeSearch() {
    this.blogService.goback();
  }
}
